import { createContext } from 'react';
/**
 * Context for the column select control.
 */
export const columnSelectContext = createContext({});
